import { NgModule } from "@angular/core";
import { Transition, UIRouter, UIRouterModule } from "@uirouter/angular";
import getEnvironmentSettings from '../../commons/configs/env-conf-loader';
const ENVIRONMENT_SETTINGS = getEnvironmentSettings();

const pages = new Map<string, string>([
  ["userProfile", "/app/user-profile"],
  ["team", "/app/admin/team"]
]);

@NgModule({
  imports: [
    UIRouterModule.forChild({
      states: [{
        name: 'openPortal',
        parent: 'ng2Root',
        url: '/portal/{page:string}'
      }],
      config: portalStateConfigFn
    })
  ]
})
export class PortalModule { }

function portalStateConfigFn(router: UIRouter) {
  router.transitionService.onBefore(
    { to: 'openPortal' },
    (transition: Transition) => {
      transition.abort();
      router.stateService.reload();
      const route = pages.get(transition.params().page);
      if (route) {
        const url = ENVIRONMENT_SETTINGS.portalHost + route;
        window.open(url, '_blank');
      }
    }
  )
}
